import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { PayloadChangePasswordType, UserService } from "@/services";
import { useSnackbar } from "@/hooks";

export const useChangePassword = () => {
  const { t: getLabel } = useTranslation();
  const { openSnackbar } = useSnackbar();

  const changePasswordMutation = useMutation({
    mutationFn: (payload: PayloadChangePasswordType) => {
      return UserService.changePassword(payload);
    },
    onSuccess: () => openSnackbar(getLabel("MSG_UPDATE_PASSWORD_SUCCESS"), "success"),
    onError: () => openSnackbar(getLabel("MSG_UPDATE_PASSWORD_FAILURE"), "error"),
  });

  const changePassword = (payload: PayloadChangePasswordType) => {
    changePasswordMutation.mutate(payload);
  };

  return {
    changePassword,
    changePasswordStatus: changePasswordMutation.status,
  };
};
